export enum CaseStatus {
  Open = 'Open',
  Closed = 'Closed',
  Suspended = 'Suspended',
}
